import React from 'react';
import { CardSeats } from './BridgeTypes';
import Hand from './Hand';
import './OffTableCards.css';

const OffTableCards: React.FC = () => {
    
    return (
        <div id="item-off-table" className="div-off-cards">
            <Hand seat={CardSeats.Off} />
        </div>
    );
};

export default OffTableCards;